import { useState } from 'react';

import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Stack, TextField } from '@mui/material';

import { IconSelectorInput } from '@@common';

import { MenuOptionModel } from '../../Models/MenuOptionModel';

type MenuInputDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	menu: MenuOptionModel | undefined;
	onMenuChange: (menu: MenuOptionModel | undefined) => void;
};

export function MenuInputDialog({ open, setOpen, menu, onMenuChange }: MenuInputDialogProps) {
	const [localMenu, setLocalMenu] = useState<MenuOptionModel>(
		menu || {
			Title: '',
			Visible: true,
		},
	);

	const handleSave = () => {
		onMenuChange(localMenu);
		setOpen(false);
	};

	const handleCancel = () => {
		setOpen(false);
	};

	return (
		<Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
			<DialogTitle>Configure Menu</DialogTitle>
			<DialogContent>
				<Stack spacing={2} sx={{ mt: 1 }}>
					<TextField
						label="Title"
						value={localMenu.Title}
						onChange={(e) => setLocalMenu({ ...localMenu, Title: e.target.value })}
						fullWidth
						required
						autoFocus
					/>
					<TextField
						label="Description"
						value={localMenu.Description || ''}
						onChange={(e) => setLocalMenu({ ...localMenu, Description: e.target.value })}
						fullWidth
						multiline
						rows={2}
					/>
					<TextField
						label="Section Title"
						value={localMenu.SectionTitle || ''}
						onChange={(e) => setLocalMenu({ ...localMenu, SectionTitle: e.target.value })}
						fullWidth
					/>
					<TextField
						label="Section Order"
						type="number"
						value={localMenu.SectionOrder ?? ''}
						onChange={(e) => setLocalMenu({ ...localMenu, SectionOrder: e.target.value !== '' ? Number(e.target.value) : undefined })}
						fullWidth
						helperText="Controls the order of this section in the menu"
					/>
					<TextField
						label="Order"
						type="number"
						value={localMenu.Order ?? ''}
						onChange={(e) => setLocalMenu({ ...localMenu, Order: e.target.value !== '' ? Number(e.target.value) : undefined })}
						fullWidth
						helperText="Controls the order of this item within its section"
					/>
					<IconSelectorInput
						label="Icon"
						value={localMenu.IconName}
						onValueChange={(iconName) => setLocalMenu({ ...localMenu, IconName: iconName })}
						placeholder="Select an icon"
					/>
					<FormControlLabel
						control={<Checkbox checked={localMenu.Visible !== false} onChange={(e) => setLocalMenu({ ...localMenu, Visible: e.target.checked })} />}
						label="Visible"
					/>
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCancel}>Cancel</Button>
				<Button onClick={handleSave} variant="contained" disabled={!localMenu.Title}>
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);
}
